// extracted by mini-css-extract-plugin
module.exports = {"card":"ShareForm_card__Z4Tfx","form":"ShareForm_form__2I3jf","stackable":"ShareForm_stackable__3fdbo"};